export interface InternalCountrySection {
  id: string;
  name: string;
  group: string;
  routerLink: string;
  countryInfoTypeId?: number;
}

export const INTERNAL_COUNTRY_SECTIONS: InternalCountrySection[] = [
  {
    id: 'blacklist-information',
    name: 'Blacklist information',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/1',
    countryInfoTypeId: 1,
  },
  {
    id: 'look-through-rules',
    name: 'Look through rules',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/2',
    countryInfoTypeId: 2,
  },
  {
    id: 'sovereign-wealth-funds',
    name: 'Sovereign wealth funds / domestic fund regime exemptions',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/3',
    countryInfoTypeId: 3,
  },
  {
    id: 'other-taxes',
    name: 'Other taxes, general considerations',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/4',
    countryInfoTypeId: 4,
  },
  {
    id: 'procedures',
    name: 'Procedures',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/5',
    countryInfoTypeId: 5,
  },
  {
    id: 'tax-treaties',
    name: 'Tax treaties',
    group: 'General information',
    routerLink: '/country/{countryId}/general-information/6',
    countryInfoTypeId: 6,
  },
  {
    id: 'tax-rate-summaries-equity',
    name: 'Equity',
    group: 'Tax rate summaries',
    routerLink: '/country/{countryId}/tax-rates-summaries/1',
  },
  {
    id: 'tax-rate-summaries-debt',
    name: 'Debt',
    group: 'Tax rate summaries',
    routerLink: '/country/{countryId}/tax-rates-summaries/2',
  },
  {
    id: 'tax-rate-summaries-derivatives',
    name: 'Derivatives',
    group: 'Tax rate summaries',
    routerLink: '/country/{countryId}/tax-rates-summaries/3',
  },
  {
    id: 'tax-rate-summaries-foreign-exchange',
    name: 'Foreign exchange',
    group: 'Tax rate summaries',
    routerLink: '/country/{countryId}/tax-rates-summaries/4',
  },
  {
    id: 'tax-news',
    name: 'Tax news',
    group: 'Country information',
    routerLink: '/country/{countryId}/tax-news',
  },
];

/**
 * Identifies the document range that will become an internal hyperlink.
 * A zero-length range inserts the destination name at the caret; otherwise
 * the existing text and formatting are preserved as the hyperlink result.
 */
export interface InternalLinkInsertionRange {
  start: number;
  length: number;
}

export function buildInternalSectionUrl(
  section: InternalCountrySection,
  countryId: number
): string {
  return section.routerLink.replace('{countryId}', String(countryId));
}
